import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { updateMember } from '../../hooks/useMembers';
import FamilyChain from '../../components/ui/FamilyChain';
import { fmtDate, initials } from '../../lib/constants';

export default function MemberDetails() {
  const { member, profile } = useAuth();
  const [editing, setEditing] = useState(false);
  const [form,    setForm]    = useState({ phone: member?.phone||'', email: member?.email||'', area: member?.area||'' });
  const [saving,  setSaving]  = useState(false);

  if (!member) return null;

  async function handleSave(e) {
    e.preventDefault(); setSaving(true);
    await updateMember(member.id, form);
    setEditing(false); setSaving(false);
    // reload page to refresh auth context member
    window.location.reload();
  }

  const groups = (member.member_groups||[]).map(g=>g.groups?.name).filter(Boolean);

  return (
    <div>
      <div className="flex-between mb-4">
        <div>
          <h1 style={{fontSize:20,fontWeight:800}}>👤 My Details</h1>
          <div style={{fontSize:13,color:'var(--text3)',marginTop:2}}>View and update your member information</div>
        </div>
        {!editing && <button className="btn btn-primary" onClick={()=>setEditing(true)}>✏️ Edit Details</button>}
      </div>

      <div className="grid-2">
        <div className="card">
          <div className="card-header">
            <div style={{display:'flex',alignItems:'center',gap:12}}>
              <div style={{width:44,height:44,borderRadius:'50%',background:'var(--red-light)',color:'var(--red-dark)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:17,fontWeight:700}}>{initials(member)}</div>
              <div>
                <h3>{member.first_name} {member.last_name}</h3>
                <span className={`badge badge-${member.membership_type==='Full Member'?'blue':'gray'}`}>{member.membership_type}</span>
              </div>
            </div>
          </div>
          <div className="card-pad">
            {editing ? (
              <form onSubmit={handleSave}>
                <div className="alert alert-info mb-4" style={{fontSize:12}}>ℹ️ You can update your contact details. For name, membership type or district changes, please contact the church office.</div>
                <div className="form-group"><label className="form-label">Phone Number</label><input className="form-input" value={form.phone} onChange={e=>setForm(f=>({...f,phone:e.target.value}))} placeholder="07XXXXXXXX" /></div>
                <div className="form-group"><label className="form-label">Email Address</label><input className="form-input" type="email" value={form.email} onChange={e=>setForm(f=>({...f,email:e.target.value}))} /></div>
                <div className="form-group"><label className="form-label">Area / Village</label><input className="form-input" value={form.area} onChange={e=>setForm(f=>({...f,area:e.target.value}))} placeholder="e.g. Thingati East" /></div>
                <div className="flex gap-2">
                  <button type="submit" className="btn btn-primary" disabled={saving}>{saving?'Saving…':'Save Changes'}</button>
                  <button type="button" className="btn btn-ghost" onClick={()=>setEditing(false)}>Cancel</button>
                </div>
              </form>
            ) : (
              <div className="grid-2">
                {[
                  ['First Name',      member.first_name],
                  ['Last Name',       member.last_name],
                  ['Other Names',     member.other_names||'—'],
                  ['Date of Birth',   fmtDate(member.dob)],
                  ['Gender',          member.gender||'—'],
                  ['Phone',           member.phone||'—'],
                  ['Email',           member.email||'—'],
                  ['National ID',     member.id_number||'—'],
                  ['District',        member.districts?.name||'—'],
                  ['Area',            member.area||'—'],
                  ['Membership Type', member.membership_type],
                  ['Status',          member.status],
                  ['Date Joined',     fmtDate(member.joined_date)],
                  ['Baptism Date',    fmtDate(member.baptism_date)],
                  ['Confirmation',    fmtDate(member.confirmation_date)],
                ].map(([l,v])=>(
                  <div key={l}>
                    <div style={{fontSize:11,fontWeight:700,color:'var(--text3)',textTransform:'uppercase',letterSpacing:.4,marginBottom:3}}>{l}</div>
                    <div style={{fontWeight:600,fontSize:14}}>{v}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div style={{display:'flex',flexDirection:'column',gap:16}}>
          {/* Groups */}
          <div className="card card-pad">
            <div style={{fontSize:11,fontWeight:700,color:'var(--text3)',textTransform:'uppercase',letterSpacing:.5,marginBottom:10}}>Groups & Ministries</div>
            <div className="flex flex-wrap gap-2">
              {groups.length ? groups.map(g=><span key={g} className="badge badge-blue">✝ {g}</span>) : <span style={{color:'var(--text3)',fontSize:13}}>No groups assigned</span>}
            </div>
          </div>

          {/* Family */}
          {member.family_id && (
            <div className="card card-pad">
              <FamilyChain familyId={member.family_id} familyName={member.families?.name} currentMemberId={member.id} />
            </div>
          )}

          <div className="alert alert-info" style={{fontSize:12}}>
            🔒 To change your name, membership type, district or family household, please contact the church office or administrator.
          </div>
        </div>
      </div>
    </div>
  );
}
